import React from "react";
import styled from "@emotion/styled";
import BasketIcon from "@ecologi/assets/icons/basket-icon.svg";
import { Link } from "../Link";

interface BasketLinkProps {
  href: string;
  itemQuantity?: number;
  className?: string;
}

const CentredLink = styled(Link)`
  display: inline-flex;
  gap: 8px;
  color: ${({ theme }) => theme.colors.snowdrop};
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 4px;
  }
`;

export const BasketLink = ({
  href,
  itemQuantity,
  className,
}: BasketLinkProps) => {
  const showQuantity = !!(itemQuantity && itemQuantity > 0);
  return (
    <CentredLink
      className={className}
      href={href}
      aria-label={`Shopping basket ${itemQuantity} items`}
    >
      <BasketIcon />
      {showQuantity && <span>{itemQuantity}</span>}
    </CentredLink>
  );
};
